import React, { useEffect, useState } from 'react';
import { ListGroup, ListGroupItem, Image, Button, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import Logo from '../../assets/images/logo1.png';
import ImgMenu1 from '../../assets/images/menu-1.png';
import ImgMenu2 from '../../assets/images/menu-2.png';
import ImgMenuPesquisa from '../../assets/images/image-pesquisa.svg';
import './styles.css';
import i18n from '../../translate/i18n';
import { MenuState } from '../../types';

// ICONS
import { ReactComponent as UsersIcon } from '../../assets/icons/Users.svg';
import { ReactComponent as PapersIcon } from '../../assets/icons/Papers.svg';
import { ReactComponent as RightIcon } from '../../assets/icons/Right.svg';
import { ReactComponent as ChartPieIcon } from '../../assets/icons/Chart-pie.svg';
import { ReactComponent as ConfigIcon } from '../../assets/icons/Config.svg';
import { ReactComponent as OfficeBuildingIcon } from '../../assets/icons/Office-building.svg';
import { ReactComponent as HelpCircle } from '../../assets/icons/Help-Circle.svg';
import { ReactComponent as HomeIcon } from '../../assets/icons/Home.svg';
import { ReactComponent as ModulesIcon } from '../../assets/icons/Modules.svg';
import { ReactComponent as SupportIcon } from '../../assets/icons/Support.svg';
import { ReactComponent as DollarIcon } from '../../assets/icons/currency-dollar.svg';

const permissao = {
  nivel_0: ['admin', 'manager', 'team member', 'sindicante'],
  nivel_1: ['admin', 'manager', 'sindicante'],
  nivel_2: ['admin', 'manager'],
  nivel_3: ['admin'],
};
function Menu(props: any) {
  const [user, setUser] = useState<any>();
  const menuState = props.menuState.menuState;

  useEffect(() => {
    const setData = async () => {
      const newUser: any = localStorage.getItem('user');
      const newUserJson = JSON.parse(newUser);
      await setUser(newUserJson);
    };
    setData();
  }, []);

  const permissao = {
    nivel_0: ['admin', 'manager', 'team member', 'sindicante'],
    nivel_1: ['admin', 'manager', 'sindicante'],
    nivel_2: ['admin', 'manager'],
    nivel_3: ['admin'],
  };

  return (
    <div className="bg-white menu position-relative">
      <Link to="/home">
        <Image className="mt-3 w-50 m-auto" src={Logo} alt="logo-sindicante-digital" />
      </Link>
      <ListGroup className="mt-3">
        <ListGroupItem className="justify-content-between align-items-center d-flex border-0">
          <Link to="/home" className="align-items-center d-flex m-0 menu-item">
            <HomeIcon className="me-3" />
            {i18n.t<string>('menu.home')}
          </Link>
        </ListGroupItem>

        {user && permissao.nivel_0.includes(user.role) && (
          <ListGroupItem className="justify-content-between align-items-center d-flex border-0 mt-2">
            <Link to="/lista-os" className="align-items-center d-flex menu-item">
              <PapersIcon className="me-3" />
              {i18n.t<string>('menu.processes')}
            </Link>
            <RightIcon />
          </ListGroupItem>
        )}

        {user && permissao.nivel_3.includes(user.role) && (
          <ListGroupItem className="justify-content-between align-items-center d-flex border-0 mt-2">
            <Link to="/lista-usuarios" className="align-items-center d-flex menu-item">
              <UsersIcon className="me-3" />
              Usuários
            </Link>
            <RightIcon />
          </ListGroupItem>
        )}

        {user && ['block'].includes(user.role) && (
          <ListGroupItem className="justify-content-between align-items-center d-flex border-0 mt-2">
            <Link to="/controle-financeiro" className="align-items-center d-flex menu-item">
              <ChartPieIcon className="me-3" />
              {i18n.t<string>('menu.financial control')}
            </Link>
            <RightIcon />
          </ListGroupItem>
        )}

        {user && permissao.nivel_1.includes(user.role) && (
          <ListGroupItem className="justify-content-between align-items-center d-flex border-0 mt-2">
            <Link to="/financeiro" className="align-items-center d-flex menu-item">
              <DollarIcon className="me-3" />
              {i18n.t<string>('menu.financial')}
            </Link>
            <RightIcon />
          </ListGroupItem>
        )}
        {user && permissao.nivel_2.includes(user.role) && (
          <ListGroupItem className="justify-content-between align-items-center d-flex border-0 mt-2">
            <Link to="/relatorio-detalhado-os" className="align-items-center d-flex menu-item">
              <ChartPieIcon className="me-3" />
              {i18n.t<string>('menu.analytical report')}
            </Link>
            <RightIcon />
          </ListGroupItem>
        )}

        {user && permissao.nivel_0.includes(user.role) && (
          <ListGroupItem className="justify-content-between align-items-center d-flex border-0 mt-2">
            <Link to="/modulos" className="align-items-center d-flex menu-item">
              <ModulesIcon className="me-3" />
              {i18n.t<string>('menu.outher modules')}
            </Link>
            <RightIcon />
          </ListGroupItem>
        )}


        <ListGroupItem className="justify-content-between align-items-center d-flex border-0 mt-2">
          <Link to="/configuracoes" className="align-items-center d-flex menu-item">
            <ConfigIcon className="me-3" />
            {i18n.t<string>('menu.settings')}
          </Link>
          <RightIcon />
        </ListGroupItem>

        <hr />
        <ListGroupItem className="justify-content-between align-items-center d-flex border-0">
          <Link to="/faq" className="align-items-center d-flex menu-item">
            <HelpCircle className="me-3" />
            {i18n.t<string>('menu.faq')}
          </Link>
        </ListGroupItem>

        <ListGroupItem className="justify-content-between align-items-center d-flex border-0 mt-2">
          <Link to="/contato" className="align-items-center d-flex menu-item">
            <SupportIcon className="me-3" />
            {i18n.t<string>('menu.request support')}
          </Link>
        </ListGroupItem>
      </ListGroup>

      {user && permissao.nivel_0.includes(user.role) && (
        <Row className="ps-2 pe-2 bottom-0">
          <Link to={'/nova-sindicancia-sinistro'}>
            <Button className="btn btn-secundary w-100 d-flex justify-content-around align-items-center position-relative">
              <svg
                width="12"
                height="16"
                viewBox="0 0 12 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M2 0C1.46957 0 0.960859 0.210714 0.585786 0.585786C0.210714 0.960859 0 1.46957 0 2V14C0 14.5304 0.210714 15.0391 0.585786 15.4142C0.960859 15.7893 1.46957 16 2 16H10C10.5304 16 11.0391 15.7893 11.4142 15.4142C11.7893 15.0391 12 14.5304 12 14V5.414C11.9999 4.88361 11.7891 4.37499 11.414 4L8 0.586C7.62501 0.210901 7.11639 0.000113275 6.586 0H2ZM7 6C7 5.73478 6.89464 5.48043 6.70711 5.29289C6.51957 5.10536 6.26522 5 6 5C5.73478 5 5.48043 5.10536 5.29289 5.29289C5.10536 5.48043 5 5.73478 5 6V8H3C2.73478 8 2.48043 8.10536 2.29289 8.29289C2.10536 8.48043 2 8.73478 2 9C2 9.26522 2.10536 9.51957 2.29289 9.70711C2.48043 9.89464 2.73478 10 3 10H5V12C5 12.2652 5.10536 12.5196 5.29289 12.7071C5.48043 12.8946 5.73478 13 6 13C6.26522 13 6.51957 12.8946 6.70711 12.7071C6.89464 12.5196 7 12.2652 7 12V10H9C9.26522 10 9.51957 9.89464 9.70711 9.70711C9.89464 9.51957 10 9.26522 10 9C10 8.73478 9.89464 8.48043 9.70711 8.29289C9.51957 8.10536 9.26522 8 9 8H7V6Z"
                  fill="white"
                />
              </svg>
              {i18n.t<string>('menu.new process')}
            </Button>
          </Link>
        </Row>
      )}

      <a
        href={'https://forms.gle/s9nbhNF3vwCBvEFM7'}
        className="container-box card-menu m-2"
        target="_blank"
        rel="noreferrer"
      >
        <img src={ImgMenuPesquisa} alt="Opine para melhorarmos!" />
        <span>
          <h4>Opine para melhorarmos!</h4>
        </span>
      </a>
    </div>
  );
}

export const mapStateToProps = (menuState: MenuState) => ({
  menuState,
});

export default connect(mapStateToProps)(Menu);
